import { render, staticRenderFns } from "./AscSticky.vue?vue&type=template&id=5bb888e4&"
import script from "./AscSticky.vue?vue&type=script&lang=js&"
export * from "./AscSticky.vue?vue&type=script&lang=js&"
import style0 from "./AscSticky.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports